import { useAvailableServers } from '@festina-life/components'
import {
  type ConfigurableServer,
  ConfigurableServers,
  isConfigurableServer,
} from '@festina-life/core'
import { useMemo } from 'react'

import { useConfigurationComponentAvailability } from '../hooks/useConfigurationComponentAvailability'

export const useAvailableServersForConfiguration =
  (): readonly ConfigurableServer[] => {
    const availableServers = useAvailableServers()
    const isConfigurationComponentAvailable =
      useConfigurationComponentAvailability()

    return useMemo(
      () =>
        isConfigurationComponentAvailable
          ? ConfigurableServers
          : availableServers.filter(isConfigurableServer),
      [availableServers, isConfigurationComponentAvailable],
    )
  }
